import React, { useCallback, useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getAreaUnassignedList } from "../../../../redux/actions/AreaAction.jsx"
import { useSubheader } from "../../../../_metronic/layout/index.js"
import { Card, CardBody, CardHeader } from "../../../../_metronic/_partials/controls/index.js"
import { RowModule } from "../../../../component/atoms/RowModule/RowModule.jsx"
import { FilterCard, TableSkeleton } from "../../../../component/molecule/index.jsx"
import { sortCaret } from "../../../../_metronic/_helpers/index.js"
import { EmptyCard, LocationMolecule, TextInput } from "../../../../component/index.jsx"
import TableView, {
  formatterRowComponent,
  initialFilterTable
} from "../../../../component/atoms/Tabel/index.jsx"
import { linkWithCtrl } from "../../../helpers/Utils.js"
import { currentUrl } from "../../../helpers/UrlParamHelper.js"
import {
  resetUrlParam,
  setDataValueAction,
  SetFilterAction,
  setPageStringActions,
  setSearchAction
} from "../../../../redux/actions/FilterAction.js"
import { toThousandConvert } from "../../../helpers/TextHelper.js"
import { useTranslation } from "react-i18next"
import { RoutesConstants } from "../../../../constants/RoutesConstants.js"
import { AREA_STATUS_STRING } from "../../../../constants/StringConstant.js"

export const ListAreaUnassigned = ({ history }) => {
  const subHeader = useSubheader()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { General, Area, UrlParam } = useSelector((state) => state)
  const formRef = useRef()

  const [search, setSearch] = useState({
    string_filter: ""
  })
  const [showFilter, setShowFilter] = useState(false)
  const [filterOn, setFilterOn] = useState(false)
  const [initialValue, setInitialValue] = useState({
    province_id: "",
    regency_id: "",
    district_id: "",
    sub_district_id: "",
    min_area: "",
    max_area: ""
  })
  const isReadOnly = false
  const [isFilter, setIsFilter] = useState(false)
  const [reset, setReset] = useState(false)
  const [min, setMin] = useState("")
  const [max, setMax] = useState("")
  const [btnFilterDisable, setBtnFilterDisable] = useState(true)
  const [isActiveSearch, setIsActiveSearch] = useState(false)

  const urlCurrent = currentUrl()
  const filterValue = UrlParam.data

  useEffect(() => {
    if (UrlParam.pageString !== urlCurrent) {
      dispatch(resetUrlParam())
    }
  }, [])

  useEffect(() => {
    if (UrlParam.search) {
      setIsActiveSearch(true)
    } else {
      setIsActiveSearch(false)
    }
  }, [])

  useEffect(() => {
    if (UrlParam.pageString !== urlCurrent) {
      dispatch(resetUrlParam())
    }
  }, [])

  useEffect(() => {
    if (UrlParam.search) {
      setIsActiveSearch(true)
    } else {
      setIsActiveSearch(false)
    }
  }, [UrlParam])

  useEffect(() => {
    if (UrlParam.search) {
      setSearch({
        string_filter: UrlParam.search
      })
    } else {
      setSearch({
        string_filter: ""
      })
    }
  }, [UrlParam.search, useCallback])

  useEffect(() => {
    const dataPage = {
      ...initialFilterTable
    }
    dispatch(setPageStringActions(urlCurrent))
    if (filterValue !== null && UrlParam.pageString === urlCurrent) {
      const data = {
        ...initialFilterTable,
        ...UrlParam.dataValue,
        string_filter: UrlParam.search,
        province_id: filterValue.province_id,
        regency_id: filterValue.regency_id,
        district_id: filterValue.district_id,
        sub_district_id: filterValue.sub_district_id,
        max_area: filterValue.max_area,
        min_area: filterValue.min_area
      }
      if (data) {
        setFilterOn(true)
        setInitialValue(data)
        dispatch(getAreaUnassignedList({ pageReq: data }))
        setShowFilter(false)
      }
    }
    if (UrlParam.pageString === urlCurrent) {
      if (UrlParam.dataValue && !UrlParam.search) {
        setSearch({
          string_filter: UrlParam.search
        })

        let param = {
          ...UrlParam.dataValue,
          string_filter: UrlParam.search
        }
        dispatch(getAreaUnassignedList({ pageReq: param }))
      }
    } else {
      dispatch(getAreaUnassignedList({ pageReq: dataPage }))
    }
  }, [UrlParam, dispatch])

  useEffect(() => {
    if (
      formRef.current.values.province_id ||
      formRef.current.values.min_area ||
      formRef.current.values.max_area
    )
      setBtnFilterDisable(false)
    else setBtnFilterDisable(true)
  }, [formRef.current, min, max])

  useEffect(() => {
    subHeader.setButton(false)
    subHeader.setTitle(t("sub_header_unassign_area"))
  }, [])

  useEffect(() => {
    if (UrlParam.search) {
      setSearch({
        string_filter: UrlParam.search
      })
    } else {
      setSearch({
        string_filter: ""
      })
    }
  }, [UrlParam, useCallback])

  const changePage = useCallback(
    (param) => {
      setSearch({
        string_filter: UrlParam.search
      })
      let newParam
      if (param.sortField != null) {
        newParam = {
          ...initialValue,
          ...search,
          ...param,
          sort: param.sortField + "," + param.sortOrder
        }
      } else if (UrlParam.search) {
        newParam = {
          ...initialValue,
          ...search,
          ...param
        }
      } else if (!UrlParam.search) {
        newParam = {
          ...initialValue,
          ...param,
          ...search
        }
      } else {
        newParam = {
          ...initialValue,
          ...param,
          ...search
        }
      }
      dispatch(getAreaUnassignedList({ pageReq: newParam }))
      dispatch(setDataValueAction(newParam))
    },
    [dispatch, initialValue, search]
  )

  useEffect(() => {
    subHeader.setButton(false)
  }, [])

  const filterOnSubmitForm = (e) => {
    setReset(false)
    const { values, submited } = e
    setIsFilter(true)
    setMin(values.min_area)
    setMax(values.max_area)
    if (submited === true) {
      let param = {
        ...initialFilterTable,
        province_id: values.province_id,
        regency_id: values.regency_id,
        district_id: values.district_id,
        sub_district_id: values.sub_district_id,
        min_area: values.min_area,
        max_area: values.max_area,
        string_filter: search.string_filter
      }

      if (param) {
        setInitialValue(param)
        dispatch(getAreaUnassignedList({ pageReq: param }))
        setShowFilter(false)
        setFilterOn(true)
        dispatch(SetFilterAction(param))
      }
    }
  }

  const onReset = () => {
    dispatch(SetFilterAction())
    setReset(true)
    setShowFilter(false)
    setIsFilter(false)
    setMin("")
    setMax("")
    setFilterOn(false)
    setInitialValue({
      province_id: "",
      regency_id: "",
      district_id: "",
      sub_district_id: "",
      min_area: "",
      max_area: ""
    })
    let param = {
      ...initialFilterTable,
      province_id: "",
      regency_id: "",
      district_id: "",
      sub_district_id: "",
      min_area: "",
      max_area: "",
      string_filter: search.string_filter
    }
    dispatch(getAreaUnassignedList({ pageReq: param }))
  }

  const seacrhFunc = (values) => {
    let param = {
      ...initialFilterTable,
      ...initialValue,
      string_filter: values.string_filter
    }
    setSearch({
      string_filter: values.string_filter
    })
    dispatch(getAreaUnassignedList({ pageReq: param }))
    dispatch(setSearchAction(values.string_filter))
    setIsFilter(true)
  }

  const handleReset = () => {
    dispatch(setSearchAction())
    setIsFilter(false)
    setSearch({
      string_filter: ""
    })
    let param = {
      ...initialFilterTable,
      ...initialValue,
      string_filter: ""
    }
    dispatch(getAreaUnassignedList({ pageReq: param }))
  }

  const handleOpenCloseFilter = (value) => {
    setShowFilter(value)
  }

  const filterComponent = (
    <>
      <LocationMolecule
        resetLocation={reset}
        name="filter"
        withoutFeedback={true}
        isReadOnly={isReadOnly}
        addressTitle={t("label_location")}
        removeHorizontalPadding={true}
      />
      <Card className="card-custom card-shadowless">
        <CardHeader title={`${t("label_land_area")} (m2)`} className="px-0" />
        <CardBody className="px-0">
          <RowModule>
            <TextInput
              editable={!isReadOnly}
              label={t("label_min")}
              name="min_area"
              placeholder={t("placeholder_min_value")}
              withoutFeedback={true}
              value={min}
              onChangeValue={setMin}
            />
          </RowModule>
          <RowModule>
            <TextInput
              editable={!isReadOnly}
              label={t("label_max")}
              name="max_area"
              placeholder={t("placeholder_max_value")}
              withoutFeedback={true}
              value={max}
              onChangeValue={setMax}
            />
          </RowModule>
        </CardBody>
      </Card>
    </>
  )

  const uiCode = (e) => {
    return (
      <>
        <p className="text-dark font-weight-bolder mb-1 font-size-lg">{e.area_code ?? "-"}</p>
      </>
    )
  }

  const uiArea = (e) => {
    return (
      <>
        <p className="text-dark">{toThousandConvert(e.land_area) ?? "-"}</p>
      </>
    )
  }

  const headerLuas = (
    <>
      {t("table_header_land_area_only")} (<span className={"text-lowercase"}>m</span>
      <sup>2</sup>)
    </>
  )

  const columns = [
    {
      dataField: "area_code",
      text: t("table_header_area_name"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiCode
      }
    },
    {
      dataField: "landArea",
      text: headerLuas,
      formatter: formatterRowComponent,
      sort: true,
      sortCaret: sortCaret,
      formatExtraData: {
        externalStyle: uiArea
      },
      onSort: (field, order) => {
        let param = {
          ...initialFilterTable,
          ...initialValue,
          sort: field + "," + order
        }
        dispatch(getAreaUnassignedList({ pageReq: param }))
      }
    },
    {
      dataField: "full_address",
      text: t("table_header_area_address"),
      formatter: formatterRowComponent
    },
    {
      dataField: "submitted_date",
      text: t("table_header_submitted_date"),
      formatter: formatterRowComponent
    }
  ]

  return (
    <>
      <FilterCard
        // seacrh
        isActiveSearch={isActiveSearch}
        placeholder={t("placeholder_insert_area_name")}
        onSubmitForm={seacrhFunc}
        initialValues={search}
        name={"string_filter"}
        innerRef={formRef}
        trigerReset={handleReset}
        // filter
        filterInnerRef={formRef}
        filterHandleSubmit={filterOnSubmitForm}
        filterFormInitialValues={initialValue}
        filterComponent={filterComponent}
        filterOnReset={onReset}
        showFilter={showFilter}
        handleOpenCloseFilter={handleOpenCloseFilter}
        filterOn={filterOn}
        btnDisable={btnFilterDisable}
      />
      <Card>
        <RowModule>
          <Card className="card-shadowless">
            <CardBody>
              {General.loading ? (
                <TableSkeleton column={4} row={10} />
              ) : Area?.pageData?.length == 0 ? (
                <EmptyCard
                  body={
                    isFilter || isActiveSearch
                      ? t("messages_response_data_not_found")
                      : t("messages_response_empty_state")
                  }
                />
              ) : (
                ""
              )}
              <TableView
                callbackAfterPageChange={changePage}
                columnProperties={columns}
                dataTable={Area.pageData}
                currentPage={Area.page.currentPage}
                currentElement={Area.page.currentElement}
                totalCount={Area.page.totalCount}
                loadingGetData={General.loading}
                ignoreSinglePage
                rowClasses={() => {
                  return "cursor-pointer"
                }}
                rowEvents={{
                  onClick: (e, row) => {
                    const url = RoutesConstants.AREA.DETAIL_AREA_UNASSIGNED(AREA_STATUS_STRING.UNASSIGN, row.area_id)
                    if (e.ctrlKey) {
                      linkWithCtrl(url)
                    } else {
                      history.push(url)
                    }
                  }
                }}
              />
            </CardBody>
          </Card>
        </RowModule>
      </Card>
    </>
  )
}
